











































import { Vue, Component } from 'vue-property-decorator';
import { Icon } from 'vant';
import { getDetail } from '../api';
import { Picker, Popup } from 'vant';
import SyPlayer from '@/components/SyPlayer.vue';
Vue.use(Icon);
Vue.use(Picker);
Vue.use(Popup);
@Component({
  components: {
    SyPlayer,
  },
})
export default class Detail extends Vue {
  showPicker = false;
  rankCondition = '';
  detailData: any = {};
  columns = ['讲红色小故事', '学习宣传活动'];
  get detail() {
    return this.$route.query;
  }
  async created() {
    const res = await getDetail(
      this.detail.id as string,
    );
    this.detailData = res.data;
    const type = this.$route.query.type;
    if (type === '1') {
      this.rankCondition = '讲红色小故事';
    } else {
      this.rankCondition = '学习宣传活动';
    }
    console.log(this.$route.query.type);
  }
  onConfirm(e: any) {
    this.rankCondition = e;
    this.showPicker = false;
  }
}
